import { PenTool } from "lucide-react";
import ContactDialog from "@/components/ContactDialog";

const PRESS = "https://images.unsplash.com/photo-1759659334772-c3a05b8178e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function ContributeBox() {
  return (
    <section data-testid="diventa-voce-section" className="max-w-7xl mx-auto px-4 my-14">
      <div className="relative overflow-hidden rounded-sm bg-legend-ink text-white grid md:grid-cols-2">
        <div className="relative min-h-[240px]">
          <img src={PRESS} alt="Redazione" className="absolute inset-0 w-full h-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-legend-ink" />
          <div className="checkered absolute bottom-0 left-0 h-2 w-full opacity-50" />
        </div>
        <div className="p-8 md:p-12">
          <span className="inline-flex items-center gap-2 text-legend-yellow font-mono uppercase text-xs tracking-widest mb-3">
            <PenTool size={14} /> Redazione
          </span>
          <h2 className="font-display font-black uppercase text-3xl md:text-4xl leading-none mb-4">
            Diventa Voce del Motorsport!
          </h2>
          <p className="text-slate-300 leading-relaxed mb-6">
            Vuoi metterti alla prova, fare pratica o esercitarti a diventare un giornalista sportivo?
            Entra nella redazione di Legend Magazine! Cerchiamo appassionati, penne curiose e amanti dei rally
            pronti a raccontare gare, piloti, anteprime e retroscena tecnici. Invia i tuoi articoli e vivi il paddock da protagonista.
          </p>
          <ContactDialog
            kind="redazione"
            title="Unisciti alla Redazione"
            trigger={
              <button data-testid="contribute-cta" className="inline-flex items-center gap-2 bg-legend-red hover:bg-legend-dark text-white font-bold uppercase tracking-wide px-6 py-3 rounded-sm transition-colors">
                Invia la tua candidatura
              </button>
            }
          />
        </div>
      </div>
    </section>
  );
}
